import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocalObservable } from "mobx-react-lite";
import { teamList } from "../services/TeamService";
import StoreAction from "./StoreAction";

const initialState = {
  teamlist: [],
};

const TeamListStore = () => {
  const store = useLocalObservable(() => ({
    /*observables*/
    ...initialState,
    ...StoreAction(initialState),
    addTeam(team) {
      if (!this.teamlist)
        if (!this.teamlist.includes(team)) this.teamlist.push(team);
    },
  }));

  const auth = getAuth();
  onAuthStateChanged(auth, (user) => {
    if (user) {
      teamList().then((value) => {
        if (value) {
          for (let i = 0; i < value.length; i++) {
            store.addTeam(value[i]);
          }
        }
      });
      console.log("team list store load");
    }
  });
  return store;
};

export default TeamListStore;
